<div class="question-pull question-pull--more">
  <div class="accordion accordion--controls">
    @for (group of grouping; track group) {
      <div class="accordion__item">
        <a href="#{{group.replace(' ','-')}}" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
          <div class="accordion__title-text">
            <h5 class="font-normal">{{group}}</h5>
          </div>
          <div class="accordion__title-caret">
            <svg class="icon"><use xlink:href="#dropdown"></use></svg>
          </div>
        </a>
        <div class="accordion__body collapse" id="{{group.replace(' ','-')}}">
          <div class="accordion__content">
            @for (level1 of getGroupingLevel(group,1); track level1) {
              <div class="custom-traffic__group {{level1?.cent_aq_answer_id}} {{ (level1?.del === 1 || level1?.edit === 1) ? 'is-active':''}} " >
                <div class="custom-traffic {{level1?.cent_aq_answer_id}}">
                  <div class="custom-traffic__body" (click)="checkRadio(level1)" >
                    <div class="custom-traffic__label" >
                      <div class="custom-traffic__icon">
                        <img src="{{level1.image_url}}" alt="" class="icon icon--lg">
                      </div>
                      <div class="custom-traffic__title"><h6>{{level1?.answer}}</h6></div>
                      <div class="custom-traffic__indi">
                        @if ((level1?.del === 0 || level1?.edit === 0)) {
                          <span class="fake-radio"></span>
                        }
                        @if (level1?.included === 1) {
                          <span class="tag-pill tag-pill--category">Included</span>
                        }
                        @if (level1?.del === 1) {
                          <a href="javascript:;" (click)="questionService?.setSelectedCoverItem(level1)" data-toggle="modal" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                            <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                          </a>
                        }
                        @if (level1?.edit === 1) {
                          <a (click)="editModal(level1)" href="javascript:;" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Policy">
                            <svg class="icon"><use xlink:href="#edit-underline"></use></svg>
                          </a>
                        }
                      </div>
                    </div>
                    <div class="custom-traffic__content">
                      <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="25" data-more-text="read more" data-less-text="read less">
                        {{level1?.info_comment}}
                      </p>
                    </div>
                  </div>
                  @if (getItk(level1)?.length > 0) {
                    <div class="custom-traffic__carousel">
                      <ngx-slick-carousel class="slider slider--compact slider--traffic"
                        #slickModal="slick-carousel"
                        [config]="slideConfig">
                        @for (itk of getItk(level1); track itk) {
                          <div ngxSlickItem style="max-width:100%" class="slider__slide" >
                            <p class="font-semibold mb-5">Important to know</p>
                            <p>{{itk.info_comment}}</p>
                          </div>
                        }
                      </ngx-slick-carousel>
                    </div>
                  }
                </div>
                @if (getGroupingLevel(group,level1)?.length > 0) {
                  <div class="custom-traffic__children">
                    <p>
                      <small class="font-semibold">Cover only available once you've added {{level1?.answer}}
                        @if (level1.tooltip) {
                          <a class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                            data-trigger="focus" data-html="true" data-placement="right"
                            [attr.data-content]="level1.tooltip">
                            <svg class="icon icon--sm">
                              <use xlink:href="#help-Icon"></use>
                            </svg>
                          </a>
                        }
                      </small>
                    </p>
                    @for (level2 of getGroupingLevel(group,level1); track level2) {
                      <div class="custom-traffic custom-traffic--child {{level2?.cent_aq_answer_id}} {{ (level2?.del === 1 || level2?.edit === 1) ? 'is-active':''}} ">
                        <div class="custom-traffic__body" (click)="checkRadio(level2)">
                          <div class="custom-traffic__label">
                            <div class="custom-traffic__icon">
                              <img src="{{level2?.image_url}}" alt="" class="icon icon--lg">
                            </div>
                            <div class="custom-traffic__title"><h6>{{level2?.answer}}</h6></div>
                            <div class="custom-traffic__indi">
                              @if ((level2?.del === 0 || level2?.edit === 0)) {
                                <span class="fake-radio" ></span>
                              }
                              @if (level2?.del === 1) {
                                <a href="javascript;" (click)="questionService?.setSelectedCoverItem(level2)"  data-toggle="modal" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                                  <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                                </a>
                              }
                              @if (level2?.edit === 1) {
                                <a href="javascript:;" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Policy">
                                  <svg class="icon"><use xlink:href="#edit-underline"></use></svg>
                                </a>
                              }
                            </div>
                          </div>
                          <div class="custom-traffic__content">
                            <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="25" data-more-text="read more" data-less-text="read less">
                              {{level2?.info_comment}}
                            </p>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

</div><br>
